<script setup>
import AppLayout from '@/layouts/AppLayout.vue'

defineProps({
  projet:          { type: Object, default: () => ({}) },
  estimation:      { type: Object, default: () => ({}) },
  photos:          { type: Array, default: () => [] },
  reports_url:     { type: String, default: null },
  compilation_url: { type: String, default: null },
  gallery_zip_request_url: { type: String, default: null },
})
</script>

<template>
  <AppLayout>
    <div class="p-8 space-y-6">
      <div class="flex items-start justify-between gap-4">
        <div>
          <div class="flex items-center gap-1.5 text-xs text-outline mb-1 flex-wrap">
            <a :href="projet.url" class="font-mono font-bold text-primary hover:brightness-125">{{ projet.code }}</a>
            <span class="material-symbols-outlined text-xs">chevron_right</span>
            <a :href="estimation.url" class="font-mono text-on-surface hover:text-primary">{{ estimation.code }}</a>
            <span class="material-symbols-outlined text-xs">chevron_right</span>
            <span class="text-outline">Galerie photo</span>
          </div>
          <h1 class="text-2xl font-black text-on-surface">Galerie photo</h1>
          <p class="text-sm text-outline mt-1">
            {{ photos.length }} photo{{ photos.length > 1 ? 's' : '' }}
          </p>
        </div>

        <div class="flex items-center gap-2">
          <a
            v-if="gallery_zip_request_url"
            :href="gallery_zip_request_url"
            class="machined-sheen px-4 py-2.5 rounded-md text-on-primary font-black text-xs uppercase tracking-widest flex items-center gap-1.5 hover:brightness-110 transition-all"
          >
            <span class="material-symbols-outlined text-sm">folder_zip</span>
            ZIP par courriel
          </a>
          <a
            v-if="compilation_url"
            :href="compilation_url"
            class="px-4 py-2.5 text-xs font-black uppercase tracking-widest rounded-md text-outline hover:text-on-surface bg-surface-container-low border border-outline-variant/10 transition-all flex items-center gap-1.5"
          >
            <span class="material-symbols-outlined text-sm">assessment</span>
            Compilation
          </a>
          <a
            v-if="reports_url"
            :href="reports_url"
            class="px-4 py-2.5 text-xs font-black uppercase tracking-widest rounded-md text-outline hover:text-on-surface bg-surface-container-low border border-outline-variant/10 transition-all flex items-center gap-1.5"
          >
            <span class="material-symbols-outlined text-sm">list</span>
            Rapports
          </a>
        </div>
      </div>

      <div v-if="photos.length" class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-5">
        <article
          v-for="photo in photos"
          :key="photo.id"
          class="group block bg-surface-container rounded-xl border border-outline-variant/10 overflow-hidden shadow hover:border-primary/30 transition-colors"
        >
          <a :href="photo.url" target="_blank" rel="noopener" class="block aspect-square bg-surface-container-high overflow-hidden">
            <img
              :src="photo.thumbnail_url || photo.url"
              :alt="photo.filename || 'Photo'"
              class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            />
          </a>
          <div class="p-3 space-y-1.5">
            <p v-if="photo.description" class="text-xs text-on-surface-variant leading-snug">
              {{ photo.description }}
            </p>
            <p v-else class="text-xs text-outline italic">Aucun descriptif</p>
            <a :href="photo.report.url" class="inline-flex items-center gap-1 text-[11px] text-primary hover:brightness-125">
              <span class="material-symbols-outlined text-xs">description</span>
              Rapport {{ photo.report.date }}
            </a>
          </div>
        </article>
      </div>

      <div v-else class="bg-surface-container rounded-xl border border-outline-variant/10 p-8 text-center">
        <p class="text-sm text-outline italic">Aucune photo n'est disponible pour cette estimation.</p>
      </div>
    </div>
  </AppLayout>
</template>
